import classNames from 'classnames/bind';

import styles from './Hobby.module.scss';
import { BookOpenReaderIcon, TVIcon } from '../Icons/Icons';
import images from '~/assets/images';

const cx = classNames.bind(styles);

function Hobby() {
    return (
        <div className={cx('wrapper')}>
            <div className={cx('inner')}>
                <div className={cx('header')}>
                    <h1>SỞ THÍCH</h1>
                </div>
                <div className={cx('content', 'grid')}>
                    <div className={cx('movie', 'row')}>
                        <div className={cx('title', 'col', 'p-2-5')}>
                            <h2 className={cx('h2')}>Xem phim</h2>
                            <div className={cx('icon', 'movie-color')}>
                                <TVIcon />
                            </div>
                        </div>
                        <div className={cx('right', 'col', 'p-9-5')}>
                            <a href="https://www.imdb.com/title/tt0816692/" target="blank">
                                <div className={cx('des')}>
                                    <div className={cx('image-content')}>
                                        <img src={images.interstellar} alt="Movie" />
                                    </div>
                                    <div className={cx('name-and-des')}>
                                        <h2
                                            title="Interstellar là một bộ phim khoa học viễn tưởng năm 2014 được đạo diễn bởi
                                            Christopher Nolan. Bộ phim kể về một nhóm phi hành gia đưa vào một chuyến đi
                                            khám phá đầu tiên về một hố đen và vũ trụ song song trong nỗ lực để tìm kiếm
                                            một nơi mới để con người có thể sinh sống do địa cầu bị trầm cảm và các
                                            nguồn lực thiếu hụt."
                                        >
                                            Interstellar
                                        </h2>
                                        <p>
                                            Interstellar là một bộ phim khoa học viễn tưởng năm 2014 được đạo diễn bởi
                                            Christopher Nolan. Bộ phim kể về một nhóm phi hành gia đưa vào một chuyến đi
                                            khám phá đầu tiên về một hố đen và vũ trụ song song trong nỗ lực để tìm kiếm
                                            một nơi mới để con người có thể sinh sống do địa cầu bị trầm cảm và các
                                            nguồn lực thiếu hụt.
                                        </p>
                                    </div>
                                </div>
                            </a>
                            <a href="https://www.imdb.com/title/tt10627776/" target="blank">
                                <div className={cx('des')}>
                                    <div className={cx('image-content')}>
                                        <img src={images.minions} alt="Movie" />
                                    </div>
                                    <div className={cx('name-and-des')}>
                                        <h2
                                            title="Phim Minions 2019 là phần tiếp theo của loạt phim hoạt hình Despicable Me.
                                            Phim xoay quanh ba chú minion Stuart, Kevin và Bob trong hành trình đi đến
                                            Hội Đồng Minions và tìm kiếm một kẻ cai trị mới. Mình ấn tượng với sự hài
                                            hước thơ ngây của những Minions và kỹ thuật tạo hình nhân vật đẹp suất sắc."
                                        >
                                            Minions
                                        </h2>
                                        <p>
                                            Phim Minions 2019 là phần tiếp theo của loạt phim hoạt hình Despicable Me.
                                            Phim xoay quanh ba chú minion Stuart, Kevin và Bob trong hành trình đi đến
                                            Hội Đồng Minions và tìm kiếm một kẻ cai trị mới. Mình ấn tượng với sự hài
                                            hước thơ ngây của những Minions và kỹ thuật tạo hình nhân vật đẹp suất sắc.
                                        </p>
                                    </div>
                                </div>
                            </a>
                            <a href="https://www.imdb.com/title/tt6105098/" target="blank">
                                <div className={cx('des')}>
                                    <div className={cx('image-content')}>
                                        <img src={images.thelionking} alt="Movie" />
                                    </div>
                                    <div className={cx('name-and-des')}>
                                        <h2
                                            title="The Lion King là một bộ phim hoạt hình nhưng mang đậm triết lý. Simba - một
                                            chú sư tử con được định sẵn để trở thành vua, nhưng biến cố kiến cậu phải bỏ
                                            nhà ra đi. Cuộc sống thoải mái, vô tư chốn lạ khiến cậu dần quên đi trách
                                            nhiệm bản thân, sống trong vỏ bọc của sự an toàn. Nhưng trách nhiệm vẫn ở
                                            đó, vương quốc còn chờ cậu. Chính động lực mãnh liệt đó khiến cậu phải phá
                                            bỏ vùng an toàn và lấn thân vào chiến đấu giành lấy những gì đã mất và mang
                                            lại phồn thịnh cho vương quốc."
                                        >
                                            The Lion King
                                        </h2>
                                        <p>
                                            The Lion King là một bộ phim hoạt hình nhưng mang đậm triết lý. Simba - một
                                            chú sư tử con được định sẵn để trở thành vua, nhưng biến cố kiến cậu phải bỏ
                                            nhà ra đi. Cuộc sống thoải mái, vô tư chốn lạ khiến cậu dần quên đi trách
                                            nhiệm bản thân, sống trong vỏ bọc của sự an toàn. Nhưng trách nhiệm vẫn ở
                                            đó, vương quốc còn chờ cậu. Chính động lực mãnh liệt đó khiến cậu phải phá
                                            bỏ vùng an toàn và lấn thân vào chiến đấu giành lấy những gì đã mất và mang
                                            lại phồn thịnh cho vương quốc.
                                        </p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className={cx('book', 'row')}>
                        <div className={cx('title', 'col', 'p-2-5')}>
                            <h2 className={cx('h2')}>Đọc sách</h2>
                            <div className={cx('icon', 'book-color')}>
                                <BookOpenReaderIcon />
                            </div>
                        </div>
                        <div className={cx('right', 'col', 'p-9-5')}>
                            <div className={cx('des')}>
                                <div className={cx('image-content')}>
                                    <img src={images.dayconlamgiau} alt="Movie" />
                                </div>
                                <div className={cx('name-and-des')}>
                                    <h2
                                        title="Dạy con làm giàu xoay quanh nội dung về cách quản lý tài chính, làm giàu thông
                                        qua cách dạy con, được diễn giải với lời kể của Robert. Mình thấy quyển sách rất
                                        bổ ích cho tất cả các bạn đặc biệt là các bạn trẻ đang có mong muốn khát khao về
                                        làm giàu."
                                        style={{ cursor: 'default' }}
                                    >
                                        Dạy con làm giàu
                                    </h2>
                                    <p>
                                        Dạy con làm giàu xoay quanh nội dung về cách quản lý tài chính, làm giàu thông
                                        qua cách dạy con, được diễn giải với lời kể của Robert. Mình thấy quyển sách rất
                                        bổ ích cho tất cả các bạn đặc biệt là các bạn trẻ đang có mong muốn khát khao về
                                        làm giàu.
                                    </p>
                                </div>
                            </div>
                            <div className={cx('des')}>
                                <div className={cx('image-content')}>
                                    <img src={images.ganhganhgonggong} alt="Movie" />
                                </div>
                                <div className={cx('name-and-des')}>
                                    <h2
                                        title='Cuốn hồi kỳ của bà Xuân Phượng là "tiếng nói của người trong cuộc" mô tả lại
                                        cuộc đời bà trải qua hai cuộc kháng chiến lớn của nước nhà, đồng thời cũng giúp
                                        mình hiểu hơn về lịch sử cũng như ý nghĩa của hai chữ "hòa bình".'
                                        style={{ cursor: 'default' }}
                                    >
                                        Gánh gánh... gồng gồng...
                                    </h2>
                                    <p>
                                        Cuốn hồi kỳ của bà Xuân Phượng là "tiếng nói của người trong cuộc" mô tả lại
                                        cuộc đời bà trải qua hai cuộc kháng chiến lớn của nước nhà, đồng thời cũng giúp
                                        mình hiểu hơn về lịch sử cũng như ý nghĩa của hai chữ "hòa bình".
                                    </p>
                                </div>
                            </div>
                            <div className={cx('des')}>
                                <div className={cx('image-content')}>
                                    <img src={images.vutruquan} alt="Movie" />
                                </div>
                                <div className={cx('name-and-des')}>
                                    <h2
                                        title="Cuốn sách mang đến cho chúng ta cảm giác gần gũi với với vị thiên tài nhân loại
                                        này. Xoay quanh về việc phân tích cuộc sống, nghệ thuật, khoa học và ý nghĩa của
                                        những phát minh mang lại cho nhân loại."
                                        style={{ cursor: 'default' }}
                                    >
                                        Vũ trụ quan của Albert einstein
                                    </h2>
                                    <p>
                                        Cuốn sách mang đến cho chúng ta cảm giác gần gũi với với vị thiên tài nhân loại
                                        này. Xoay quanh về việc phân tích cuộc sống, nghệ thuật, khoa học và ý nghĩa của
                                        những phát minh mang lại cho nhân loại.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Hobby;
